import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  ORDER_STATUS_BLOCK_DATA_SOURCE,
  OrderStatusBlockDataSource,
} from './order-status-block-view-model';
import { OrderStatusBlockPreviewDataSource } from './order-status-block-preview-data-source';
import { OrderStatusBlockStoreDataSource } from './order-status-block-store-data-source';

export function provideOrderStatusBlockDataSource(): Provider[] {
  return [
    OrderStatusBlockStoreDataSource,
    OrderStatusBlockPreviewDataSource,
    {
      provide: ORDER_STATUS_BLOCK_DATA_SOURCE,
      useFactory: (): OrderStatusBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(OrderStatusBlockPreviewDataSource)
          : inject(OrderStatusBlockStoreDataSource);
      },
    },
  ];
}
